/** @typedef {Record<string, unknown> & {section_id?: string}} ReportSection */

/**
 * Section-level diffing for AI update flows.
 *
 * An AI rebuild (comps, photos) can legitimately change MORE than the section
 * the agent acted on: the worker runs a consistency pass that updates pricing
 * or recommendation citations in the executive summary and conclusion. Any
 * section whose content changed is no longer the thing the agent blessed, so
 * its "Looks good" must be cleared — this finds exactly those sections.
 *
 * @param {ReportSection[] | null | undefined} prev sections before the update
 * @param {ReportSection[] | null | undefined} next sections after the update
 * @returns {string[]} section_ids present in `next` whose content differs
 */
export const changedSectionIds = (prev, next) => {
  /** @type {Record<string, string>} */
  const before = {};
  for (const s of prev || []) {
    if (s?.section_id) before[s.section_id] = JSON.stringify(s);
  }
  /** @type {string[]} */
  const changed = [];
  for (const s of next || []) {
    if (!s?.section_id) continue;
    if (before[s.section_id] !== undefined && before[s.section_id] !== JSON.stringify(s)) {
      changed.push(s.section_id);
    }
  }
  return changed;
};
